"use client";

import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

interface ProjectOverviewProps {
  overview: string;
  id?: string;
}

const ProjectOverview: React.FC<ProjectOverviewProps> = ({ overview, id }) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".overview-content",
        { y: 24, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 85%",
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} id={id} className="py-24 border-t border-[#e8e8e8]">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Left Column - Title (Full Column) */}
            <div className="flex justify-start">
              <h2 className="overview-content text-sm uppercase tracking-[0.15em] text-[#6f6f6f] font-pp-neuebit">
                overview
              </h2>
            </div>

            {/* Right Column - Content (Full Column) */}
            <div className="overview-content prose prose-lg max-w-none space-y-4">
              {overview.split("\n\n").map((paragraph, index) => (
                <p
                  key={index}
                  className="text-xl md:text-xl text-[#6b6b6b] leading-relaxed font-neue-regrade-variable"
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectOverview;
